import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, keep the ascending order */

const useStyles = makeStyles({
    fixedLayout: {
        paddingTop: 20,
        paddingRight: 20,
    },
});

export function FixedLayout(props) {
    const classes = useStyles();

    return <div className={classes.fixedLayout}>{props.children}</div>;
}

export function IncludeExcludeLayout({ type, label, children, marginBottom, compact }) {
    /**
     * A layout component to display included/excluded items with an icon and label.
     * @param {string} type - The type of layout, either 'Include' or 'Exclude'.
     * @param {string} label - An optional label to display next to the icon. If not provided, the type will be used as the label.
     * @param {ReactNode} children - The content to display inside the layout.
     * @param {boolean} marginBottom - Whether to add a bottom margin to the layout.
     * @param {boolean} compact - Whether to use a compact layout with smaller icons and no wrapping. Needed to use inside a table
     **/
    return (
        <Box mb={marginBottom ? 1 : ''}>
            <Box mb={1}>
                <Grid
                    container
                    alignItems="center"
                    style={
                        compact ? { display: 'flex', alignItems: 'center', flexWrap: 'nowrap' } : {}
                    }
                >
                    <Box mr={1}>
                        {type === 'Include' ? (
                            <CheckCircleOutlineIcon
                                color="primary"
                                style={
                                    compact
                                        ? {
                                              display: 'inline-block',
                                              width: '20px',
                                              height: '20px',
                                              flexShrink: 0,
                                          }
                                        : {}
                                }
                            />
                        ) : (
                            <CancelOutlinedIcon
                                color="secondary"
                                style={
                                    compact
                                        ? {
                                              display: 'inline-block',
                                              width: '20px',
                                              height: '20px',
                                              flexShrink: 0,
                                          }
                                        : {}
                                }
                            />
                        )}
                    </Box>
                    <div>{label ? label : type}</div>
                </Grid>
            </Box>
            <Box ml={3.7}>{children}</Box>
        </Box>
    );
}

const noResultsStyles = makeStyles({
    image: {
        width: '100%',
    },
});

export function NoResults(props) {
    const classes = noResultsStyles();
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            height="60vh"
        >
            <Box width="300" height="auto">
                <img
                    className={classes.image}
                    src="/images/audience-segments/audience-segments-not-found.png"
                />
            </Box>
            <Box mt={2}>
                <Typography variant="h6" gutterBottom>
                    {props.title}
                </Typography>
            </Box>
            {props.buttonText && (
                <Button variant="contained" color="primary" onClick={props.onClick} to={props.to}>
                    {props.buttonText}
                </Button>
            )}
        </Box>
    );
}
